import {Dienst} from '../dienst/dienst';

export class ThuisverzorgerDienst {

  static deserialize(dto: ThuisverzorgerDienstDto): ThuisverzorgerDienst {
    return new ThuisverzorgerDienst(
      dto.id,
      dto.zoneIds,
    );
  }

  static new(dienst: Dienst, zoneIds: Array<string>): ThuisverzorgerDienst {
    return new ThuisverzorgerDienst(
      dienst.getId(),
      zoneIds,
    );
  }

  constructor(
    private id: string,
    private zoneIds: Array<string>,
  ) {
  }

  getId(): string {
    return this.id;
  }

  hasId(id: string): boolean {
    return this.id === id;
  }

  getZoneIds(): Array<string> {
    return this.zoneIds;
  }

  setZoneIds(zoneIds: Array<string>): void {
    this.zoneIds = zoneIds;
  }

  isValid(): boolean {
    return this.zoneIds.length > 0;
  }

  toDto() {
    return {
      id: this.id,
      zoneIds: this.zoneIds,
    };
  }
}

export interface ThuisverzorgerDienstDto {
  id: string;
  zoneIds: Array<string>;
}
